module.exports = __webpack_public_path__ + "img/Virtual_Influencers.7f0d2405.jpg";